import { defineComponent as _defineComponent } from 'vue'
import { useRirekishoPreview } from '@/composables/format-edit/useRirekishoPreview'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
  formatId?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoBeautyPreview',
  props: {
    formatData: null,
    basicData: null,
    previewScale: { default: 1 },
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false },
    formatId: null
  },
  setup(__props: any, { expose }) {

const props = __props as { formatData: Record<string, any>, basicData: Record<string, any>, previewScale: number, currentCardId: string | string[], idPrefix: string, isSample: boolean, formatId?: string };



const {
  checkValid,
  formLib,
  scaleStyle,
  highlightMessage,
  goCardTo,
  highLightClass,
  classObject,
  errorMessages,
  tel,
  contactTel,
  age,
  formatedCreateDate,
  isMale,
  isFemale,
  isGenderDisplay,
  eduJobHistoryTable,
  licenseHistoryTable
} = useRirekishoPreview(props, {
  maxEduJobRows: 22,
  maxLicenseRows: 6,
  textareaMaxHeights: { reason: 175, reasonNew: 175, hobby: 175, request: 180 },
  overflowFields: [
    'reason',
    'reasonNew',
    'hobby',
    'request',
    'addressFurigana'
  ],
  revalidateOnFormatDataChange: true
})

expose({ checkValid })

return { __sfc: true,props, checkValid, formLib, scaleStyle, highlightMessage, goCardTo, highLightClass, classObject, errorMessages, tel, contactTel, age, formatedCreateDate, isMale, isFemale, isGenderDisplay, eduJobHistoryTable, licenseHistoryTable }
}

})